import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getProtocolPhyto.success: {
            return action.payload;
        }

        case constants.getProtocolPhyto.error: {
            return initialState;
        }

        case constants.getProtocolPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}